import React from 'react';

export default props => {
    return (
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 -6.19896e-07L4 8M4 8L7 5.14286M4 8L1 5.14286" stroke="#F2C94C" stroke-width="2"/>
        </svg>
    );
};
